/**
 * @ignore
 */
import { useSelector } from '../actions/types';
import * as selectors from '../selectors';
export function useArticlePageData(articleId) {
    const fetchingStatus = useSelector((state) => selectors.page.articlePageFetchingStatus(state, articleId));
    const article = useSelector((state) => selectors.categoryTree.articleFull(state, articleId));
    return {
        fetchingStatus,
        data: { article },
    };
}
//# sourceMappingURL=useArticlePageData.js.map